import { createFileRoute } from "@tanstack/react-router";

import { FollowUpActionsPage } from "@/components/pages/FollowUpActionsPage";
import {
  type FollowUpActionsTab,
  VALID_TABS,
} from "@/lib/follow-up-actions/follow-up-actions-list";

type FollowUpActionsSearch = {
  tab?: FollowUpActionsTab;
};

export const Route = createFileRoute("/_authenticated/follow-up-actions/")({
  validateSearch: (search: Record<string, unknown>): FollowUpActionsSearch => ({
    tab: VALID_TABS.includes(search.tab as FollowUpActionsTab)
      ? (search.tab as FollowUpActionsTab)
      : undefined,
  }),
  component: FollowUpActionsPage,
});
